import { render, staticRenderFns } from "./RedactorWordsCountFollowUp.vue?vue&type=template&id=923706d2&"
import script from "./RedactorWordsCountFollowUp.vue?vue&type=script&lang=js&"
export * from "./RedactorWordsCountFollowUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports